import { clocksNow, combine, generateUUID } from '@datadog/browser-core';
import { ActionType as ActionTypeEnum, FrustrationType as FrustrationTypeEnum } from '../../rawRumEvent.types';
export function trackManualActions(lifeCycle, actionTracker, onManualActionCompleted) {
    const activeManualActions = new Map();
    lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, () => activeManualActions.clear());
    function startManualAction(name, options = {}, startClocks = clocksNow()) {
        var _a;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const existingAction = activeManualActions.get(lookupKey);
        if (existingAction) {
            existingAction.trackedAction.discard();
            activeManualActions.delete(lookupKey);
        }
        const trackedAction = actionTracker.createTrackedAction(startClocks);
        activeManualActions.set(lookupKey, {
            name,
            type: options.type,
            context: options.context,
            trackedAction,
        });
    }
    function stopManualAction(name, options = {}, stopClocks = clocksNow()) {
        var _a, _b;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const activeAction = activeManualActions.get(lookupKey);
        if (!activeAction) {
            return;
        }
        activeAction.trackedAction.stop(stopClocks.relative);
        const frustrationTypes = [];
        if (activeAction.trackedAction.counts.errorCount > 0) {
            frustrationTypes.push(FrustrationTypeEnum.ERROR_CLICK);
        }
        const manualAction = {
            id: activeAction.trackedAction.id,
            name: activeAction.name,
            type: ((_b = options.type) !== null && _b !== void 0 ? _b : activeAction.type) || ActionTypeEnum.CUSTOM,
            startClocks: activeAction.trackedAction.startClocks,
            duration: activeAction.trackedAction.duration,
            context: combine(activeAction.context, options.context),
            counts: activeAction.trackedAction.counts,
            frustrationTypes,
        };
        onManualActionCompleted(manualAction);
        activeManualActions.delete(lookupKey);
    }
    function addInstantAction(action) {
        onManualActionCompleted({ id: generateUUID(), frustrationTypes: [], ...action });
    }
    function stop() {
        activeManualActions.forEach((activeAction) => activeAction.trackedAction.discard());
        activeManualActions.clear();
    }
    return {
        addAction: addInstantAction,
        startAction: startManualAction,
        stopAction: stopManualAction,
        stop,
    };
}
//# sourceMappingURL=trackManualActions.js.map